import { CommonModule } from '@angular/common'
import { Component, Input, OnInit } from '@angular/core'
import { DynamicTextComponent } from '../dynamic-text/dynamic-text.component'
import { ChannelBannerTextWidget } from 'htv-lib'

@Component({
  selector: 'app-channel-banner-text',
  standalone: true,
  imports: [CommonModule, DynamicTextComponent],
  templateUrl: './channel-banner-text.component.html',
  styleUrls: [],
})
export class ChannelBannerTextComponent implements OnInit {
  @Input() config!: ChannelBannerTextWidget
  text = ''

  constructor() {
    // do nothing
  }

  ngOnInit(): void {
    this.text = this.config.text ?? ''
  }
}
